// extracted by mini-css-extract-plugin
export var containerStyle = "slider-module--containerStyle--6yBxP";
export var prevStyle = "slider-module--prevStyle--vK2P0";
export var nextStyle = "slider-module--nextStyle--3MJ-i";
export var viewportStyle = "slider-module--viewportStyle--Zsu5v";
export var carouselStyle = "slider-module--carouselStyle--24uwz";
export var slideStyle = "slider-module--slideStyle--3DpT0";